// extracted by mini-css-extract-plugin
export default {"container":"bF-z","dimension":"cF-z","dimensionLabels":"dF-z"};